import { pubSub } from '@utils/PubSub';
import { trapFocus, releaseFocus } from './global-functions';

export default class ExitOverlay {
  constructor(context) {
    this.moduleEl = context;
    pubSub.subscribe('dy:exitOverlay:init', () => {
      //only load the overlay once per user session. this is also set in the DY campaign, but its implementation has been inconsistent at best
      if (!sessionStorage.getItem('exitOverlayLoaded')) this.initExit();
    });
    pubSub.unsubscribe('dy:exitOverlay:init', this.initExit());
  }

  initExit() {
    if (window?.Brooklinen.exitOverlay) {
      const exitOverlay = window?.Brooklinen.exitOverlay;
      const matchedModuleObj = exitOverlay.find(
        (module) => module.general.id == this.moduleEl.dataset.dyId
      );
      if (matchedModuleObj) this.updateModule(matchedModuleObj);
      trapFocus(this.moduleEl);

      //adding an extra layer of security to DY's once per session exit overlay trigger
      sessionStorage.setItem('exitOverlayLoaded', true);
    }
    // Bind close function to both CTA and X
    document
      .querySelectorAll('#overlayModal .close')
      .forEach((close) => close.addEventListener('click', this.closeModal));
  }

  updateSettings(obj) {
    const { moduleEl } = this,
      { dataset } = this.moduleEl,
      { textColor, backgroundColor } = obj.general;

    // Update colors and fonts
    if (backgroundColor !== '') moduleEl.dataset.bgColor = backgroundColor;
    if (textColor !== '') moduleEl.dataset.color = textColor;
    // Update Data
    dataset.metaSrc = 'dy';
  }

  updateContent(obj) {
    const { moduleEl } = this,
      { headline, subcopy, button } = obj.copy,
      headlineEl = this.moduleEl.querySelector('.headline'),
      headlineDesktopEl = headlineEl.querySelector('.desktop'),
      headlineMobileEl = headlineEl.querySelector('.mobile'),
      subcopyEl = this.moduleEl.querySelector('.caption'),
      subcopyDesktopEl = subcopyEl.querySelector('.desktop'),
      subcopyMobileEl = subcopyEl.querySelector('.mobile'),
      buttonWrapperEl = this.moduleEl.querySelector('.button'),
      buttonEl = buttonWrapperEl.querySelector('a'),
      buttonDesktopEl = buttonEl.querySelector('.desktop'),
      buttonMobileEl = buttonEl.querySelector('.mobile');

    // Update headline
    if (headline.desktop !== '') headlineDesktopEl.innerHTML = headline.desktop;
    if (headline.mobile !== '') headlineMobileEl.innerHTML = headline.mobile;
    // Update subcopy
    if (subcopy.desktop !== '') subcopyDesktopEl.innerHTML = subcopy.desktop;
    if (subcopy.mobile !== '') subcopyMobileEl.innerHTML = subcopy.mobile;
    // Update buttons
    if (button.desktopCopy !== '')
      buttonDesktopEl.innerHTML = button.desktopCopy;
    if (button.mobileCopy !== '') buttonMobileEl.innerHTML = button.mobileCopy;
    if (button.link !== '') buttonEl.href = button.link;
    buttonWrapperEl.classList.remove('button--primary', 'button--secondary');
    buttonWrapperEl.classList.add(button.style);
  }

  removeAttributes(element) {
    while (element.attributes.length > 0) {
      element.removeAttribute(element.attributes[0].name);
    }
  }

  setAttributes(element, attributes) {
    Object.keys(attributes).forEach((attr) => {
      element.setAttribute(attr, attributes[attr]);
    });
  }

  updateModule(obj) {
    const { moduleEl } = this;
    this.updateSettings(obj);
    this.updateContent(obj);

    // Show DY content
    moduleEl.style.zIndex = '9999';
    moduleEl.classList.add('active');
  }

  closeModal = () => {
    const { moduleEl } = this;
    // Lower z-index when transition is complete
    moduleEl.classList.remove('active');
    releaseFocus();
    setTimeout(() => {
      moduleEl.style.zIndex = '-1';
    }, 400);
  };
}
